const isVercel = process.env.NEXT_PUBLIC_VERCEL || process.env.VERCEL;
const isNetlify = process.env.NETLIFY == "true";
const environment = process.env.NODE_ENV;
const region = process.env.REGION || void 0;
export {
  environment,
  isNetlify,
  isVercel,
  region
};
//# sourceMappingURL=platform.js.map
